import React from "react";
import "./GuideTemplate.css";

const GuideTemplate = (props: any) => {
  const {
    imgSrc,
    paragraphText,
    onClick,
    mainContainerClass,
    imageContainerClass,
    imageClass,
    textContainerClass,
    textClass,
  } = props;

  return (
    <div className={mainContainerClass} onClick={onClick}>
      <div className={imageContainerClass}>
        <img src={imgSrc} alt="" className={imageClass} />
      </div>
      <div className={textContainerClass}>
        <p className={textClass}>{paragraphText}</p>
      </div>
    </div>
  );
};

export default GuideTemplate;
